export default __webpack_public_path__ + "static/media/solarp3.9a615909.jpg";